module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-action-button"
  }, [_c('ModalReveal', {
    ref: "prompt"
  }, [_vm._t("prompt"), _c('div', {
    staticClass: "row columns",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.disabled || _vm.spin
    },
    on: {
      "click": _vm.callAction
    }
  }, [(_vm.spin) ? _c('span', {
    staticClass: "fa fa-spinner fa-spin",
    class: {
      spin: _vm.spin
    }
  }) : _c('span', [_vm._v("Save")])])])], 2), _c('button', {
    staticClass: "action-button",
    class: {
      colorClass: _vm.colorClass, button: _vm.button
    },
    attrs: {
      "disabled": _vm.disabled || _vm.spin
    },
    on: {
      "click": _vm.call
    }
  }, [(_vm.spin) ? _c('span', {
    staticClass: "fa fa-spinner fa-spin",
    class: {
      spin: _vm.spin
    }
  }) : _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bfa1cfdc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/ActionButton.vue
// module id = 2674
// module chunks = 1